import './Contact.scss'
import EstimateForm from '../../Components/EstimateForm/EstimateForm'


function Contact() {
  return (
    <div className='contact'>
      <EstimateForm />
    </div>
  )
}

export default Contact